import jquery from "jquery";
window.$ = window.jQuery = jquery;

import "../scss/style.scss";
import "./index.js";
